import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { SheetItemComponentBase } from 'src/app/services/sheets-renderer.service';
import { Row } from 'src/app/types/aggregate-graph.types';
import { OxygenInstructions, OxygenMethod } from 'src/app/types/sheet-instruction.types';
import { ItemContentComponent } from '../../item-content/item-content.component';
import { InstructionBoxComponent } from '../../instruction-box/instruction-box.component';

@Component({
    selector: 'app-oxygen-item',
    templateUrl: './oxygen-item.component.html',
    styleUrl: './oxygen-item.component.scss',
    imports: [ItemContentComponent, InstructionBoxComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OxygenItemComponent implements SheetItemComponentBase {

	row!: Row;
	instructions!: OxygenInstructions;
	oxygenMethod!: string[];
    @Input() startLabel!: string;
    @Input() endLabel!: string;
	@Input('row') set updateRow(row: Row) {
		this.row = row;
		this.instructions = row.instructions as OxygenInstructions;
		this.oxygenMethod = Object.values(this.instructions).map(instruction => this.getOxygenMethod(instruction.oxygenMethod));
	}
	
	constructor() {
	}

	private getOxygenMethod(oxygenMethod: OxygenMethod | null) {
		switch (oxygenMethod) {
			case OxygenMethod.Cpap: return 'CPAP';
			case OxygenMethod.HighFlow: return 'High Flow';
			case OxygenMethod.NasalProngs: return 'Nasal Prongs';
			case OxygenMethod.OxygenKennel: return 'Oxygen Kennel';
			default: return '';
		}
	}
}